<template>
  <b-form id="advertiser_submit" @submit="sendForm">
    <div class="row">
      <div class="col-sm-12">
        <b-form-group
            label="Сейлз Менеджер"
            label-for="sales_manager">
          <v-select
              id="sales_manager"
              label="name"
              :options="salesManagers"
              :reduce="manager => manager.id"
              required
              multiple
              v-model="form.sales_managers">
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
        </b-form-group>

        <b-form-group
            label="Аккаунт Менеджер"
            label-for="account_manager">
          <v-select
              id="account_manager"
              label="name"
              :options="accountManagers"
              :reduce="accountManager => accountManager.id"
              required
              v-model="form.account_manager_id">
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
        </b-form-group>

        <b-form-group label="Канал продаж" v-if="this.$currentUser.department === 'adkey'">
          <v-select :options="channels"
                    :reduce="channel => channel.value"
                    required
                    :searchable="false"
                    v-model="form.channel">
          </v-select>
          <span class="alert-danger" v-for="error in formErrors.channel">Укажите канал продаж.</span>
        </b-form-group>

        <b-form-group label="Дата изменения Аккаунт Менеджера"
                      label-for="title">
          <datepicker input-class="form-control"
                      class="date"
                      :language="ru"
                      v-model="form.account_manager_change_date"
                      placeholder=""></datepicker>
        </b-form-group>

        <b-button
                  type="submit"
                  class="float-right"
                  variant="primary">Сохранить и выйти
        </b-button>
      </div>
    </div>

    <div class="form-errors"></div>
  </b-form>

</template>

<script>

import advertisersService from "../../../services/advertisersDataService";
import advertiserMixin from "../mixins/Advertiser/createUpdateMixin";
import Datepicker from 'vuejs-datepicker'
import {ru} from '../../../services/customLocaleDatepicker'

export default {
  name: "MassUpdateAdvertisersModal",
  mixins: [advertiserMixin],
  components: {
    Datepicker: Datepicker
  },
  props: {
    advertisers: {},
  },
  data() {
    return {
      form: {
        sales_managers: null,
        account_manager_id: null,
        channel: null,
        account_manager_change_date: null
      },
      ru: ru,
      channels: [
        {
          label: 'Конференция',
          value: 'conference'
        },
        {
          label: 'Нетворкинг',
          value: 'networking'
        },
        {
          label: 'Рекомендация',
          value: 'recommendation'
        },
        {
          label: 'Холодные продажи',
          value: 'coldsale'
        },
        {
          label: 'Запрос через сайт/соц.сети',
          value: 'website'
        }
      ],
    }
  },
  methods: {
    sendForm() {
      let advertisersArray = []

      Object.keys(this.advertisers).forEach(function(key){
        if (this.advertisers[key]) {
          advertisersArray.push(key)
        }
      }.bind(this))

      this.form.advertisersIds = advertisersArray
      return advertisersService.updateAdvertisers(this.form)
    }
  },
  mounted() {
    this.getActiveAccountManagers()
    this.getActiveSalesManagers()
  }

}
</script>

<style>
.vdp-datepicker input {
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/front/modals/MassUpdateAdvertisersModal.vue